import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraHubGrid } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
import { useGovOrgNoticeSummary } from './hooks';
const planes = [
    {
        plane: 'MARKET',
        label: 'Market',
        tone: 'info'
    },
    {
        plane: 'GROWTH',
        label: 'Growth',
        tone: 'success'
    },
    {
        plane: 'DELIVERY',
        label: 'Delivery',
        tone: 'teal'
    },
    {
        plane: 'VEHICLES',
        label: 'Vehicles',
        tone: 'neutral'
    }
];
/** The market desk has no office filter; its agency filter matches the office by name. */ export const noticesSearchHref = (orgName)=>`/opportunities?agency=${encodeURIComponent(orgName)}`;
function MarketNotices({ orgId, orgName }) {
    const summary = useGovOrgNoticeSummary(orgId).data;
    if (!summary) return null;
    const { totalSinceYear: n, sinceYear, openNow } = summary;
    return /*#__PURE__*/ _jsx(SpecraText, {
        as: "p",
        size: "meta",
        tone: "muted",
        "data-testid": Testids.registryGovOrg.noticesLine,
        children: n === 0 ? 'No notices yet' : /*#__PURE__*/ _jsx(SpecraLink, {
            href: noticesSearchHref(orgName),
            renderLink: renderRouterLink,
            children: `${n} ${n === 1 ? 'notice' : 'notices'} since ${sinceYear} · ${openNow} open now`
        })
    });
}
export function WhereTheyShowUp({ cards, orgId, orgName }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Where they show up"
            }),
            /*#__PURE__*/ _jsx(SpecraHubGrid, {
                columns: 4,
                renderLink: renderRouterLink,
                getItemTestId: ()=>Testids.registryGovOrg.showUpCard,
                items: planes.map((p)=>{
                    const card = cards.find((c)=>c.plane === p.plane);
                    return {
                        id: p.plane,
                        title: card?.title || 'Nothing linked yet',
                        description: card?.summary || undefined,
                        eyebrow: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: p.tone,
                            children: p.label
                        }),
                        href: card?.primary ? registryHref(card.primary) ?? undefined : undefined
                    };
                })
            }),
            /*#__PURE__*/ _jsx(MarketNotices, {
                orgId: orgId,
                orgName: orgName
            }),
            cards.length === 0 && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Nothing you can see links to this office yet."
            })
        ]
    });
}
